<template>
  <WsChips001 :value="value" />
</template>

<script>
export default {
  data(){
    return {
      value: [
        { leadingIcon: "icon-water", text: "dddd", color: "yellow" },
        { leadingIcon: "icon-water", text: "dddd", color: "red" },
        { leadingIcon: "icon-water", text: "dddd", color: "light-gray" },
        { leadingIcon: "icon-water", text: "dddd", color: "dark-gray" },
        { leadingIcon: "icon-water", text: "dddd", color: "green" },
        { leadingIcon: "icon-water", text: "dddd", color: "transparent" },
        { leadingIcon: "icon-water", text: "dddd", color: "mediumBlue" },
      ],
    }
  }
}
</script>